import { toggleConfirmDialog } from "../../store/slice/dialogSlice";
import { useDispatch, useSelector } from "react-redux";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Typography } from "@mui/material";
import { showSuccessToast } from "../../constToast/constToast";
import { useGetCurrentUserInfoQuery } from "../../store/api/userApi";
import { usePostVendorRfqChangeStatusMutation } from "../../store/api/vendorApi";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";


const AcceptRfqDialog = ({ data }) => {
  const dispatch = useDispatch()
  const open = useSelector((state) => state.dialogSlice.confirmDialog)
  const { data: userInfoData } = useGetCurrentUserInfoQuery();
  const [postChangeStatus] = usePostVendorRfqChangeStatusMutation()
  const vendorRfqData = useSelector((state) => state.mainToCard.vendorRfqData)

  const dayjs = require('dayjs')
  const today = dayjs(new Date())

  const handleClose = () => {
    dispatch(toggleConfirmDialog())
  }
  const navigate = useNavigate();
  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle>Accept</DialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText>
          <Typography component="span">
            <strong>Are you sure, you want to accept {data?.rfqNo}?</strong>
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => {
            postChangeStatus({
              rfqMainId: data?.id,
              status: 1,
              vendorCode: userInfoData?.data?.vendorCode,
              comment: null,
              rejectReasonId: null
            })
            handleClose()
            showSuccessToast('Succesfully')
            navigate(`/rfq-information`)
          }}
          disabled={data?.status == 2 || !(vendorRfqData[0]?.participationStatus == 'Issued' && dayjs(vendorRfqData[0]?.rfqDeadline).isAfter(today))}
        >
          Accept
        </Button>
        <Button variant="outlined" onClick={handleClose} sx={{ color: 'gray', borderColor: '#D3D3D3' }}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AcceptRfqDialog